export default __webpack_public_path__ + "static/bg-feature-powered-light-aa3e2aefe57111f07bfbfa49b7afafe9.png";